import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 全局包括echarts
// 引入Echarts
//import echarts from "echarts"
//Vue.prototype.$echarts = echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
//Vue.prototype.$globalVariable = globalVariable
//Vue.prototype.$globalProperty = '这是一个全局属性';



Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  
  router,
  store,
  data: {
    globalVariable: ''//'我是一个全局变量'
  },
  render: h => h(App)
}).$mount('#app')
